import { useEffect, useRef } from "react";

const GoldParticles = ({ density = 70, className = "" }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        let rafId;
        let particles = [];
        const dpr = Math.min(window.devicePixelRatio || 1, 2);

        const resize = () => {
            const { clientWidth, clientHeight } = canvas.parentElement;
            canvas.width = clientWidth * dpr;
            canvas.height = clientHeight * dpr;
            canvas.style.width = `${clientWidth}px`;
            canvas.style.height = `${clientHeight}px`;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };

        const spawn = () => {
            const { clientWidth: w, clientHeight: h } = canvas.parentElement;
            particles = Array.from({ length: density }, () => ({
                x: Math.random() * w,
                y: Math.random() * h,
                r: Math.random() * 1.8 + 0.4,
                vy: -(Math.random() * 0.25 + 0.06),
                vx: (Math.random() - 0.5) * 0.12,
                phase: Math.random() * Math.PI * 2,
                speed: Math.random() * 0.015 + 0.005,
            }));
        };

        const tick = () => {
            const { clientWidth: w, clientHeight: h } = canvas.parentElement;
            ctx.clearRect(0, 0, w, h);
            for (const p of particles) {
                p.phase += p.speed;
                p.x += p.vx + Math.sin(p.phase) * 0.08;
                p.y += p.vy;
                if (p.y < -6) {
                    p.y = h + 6;
                    p.x = Math.random() * w;
                }
                if (p.x < -6) p.x = w + 6;
                if (p.x > w + 6) p.x = -6;
                const twinkle = 0.35 + 0.65 * Math.abs(Math.sin(p.phase * 2));
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(229, 184, 42, ${0.55 * twinkle})`;
                ctx.shadowColor = "rgba(247, 220, 129, 0.8)";
                ctx.shadowBlur = 6 * twinkle;
                ctx.fill();
                ctx.shadowBlur = 0;
            }
            rafId = requestAnimationFrame(tick);
        };

        resize();
        spawn();
        tick();
        window.addEventListener("resize", resize);
        return () => {
            cancelAnimationFrame(rafId);
            window.removeEventListener("resize", resize);
        };
    }, [density]);

    return (
        <canvas
            ref={canvasRef}
            className={`pointer-events-none absolute inset-0 ${className}`}
            aria-hidden="true"
        />
    );
};

export default GoldParticles;
